export const DRAWERS = {
    aiAssignProductAreas: 'aiAssignProductAreas',
    aiSettingsContext: 'aiSettingsContext',
    automationRule: 'automationRule',
    aiTemplates: 'aiTemplates',
    callPlayer: 'callPlayer',
    createTemplate: 'createTemplate',
    customStatuses: 'customStatuses',
    feedbackViews: 'feedbackViews',
    ideaCreate: 'ideaCreate',
    highlight: 'highlight',
    onboarding: 'onboarding',
    topic: 'topic',
    vocItem: 'vocItem',
    vocItemStacked: 'vocItemStacked',
};

export const MODALS = {
    deleteCategory: 'deleteCategory',
    deleteLabel: 'deleteLabel',
    editCategory: 'editCategory',
    editLabel: 'editLabel',
    saveFeedbackView: 'saveFeedbackView',
    vocItemBulkLinkItem: 'vocItemBulkLinkItem',
    vocItemBulkActions: 'vocItemBulkActions',
    vocItemUpdateLog: 'vocItemUpdateLog',
};

export const LARGE_DRAWER_WIDTH = '650px';

export const getLargeDrawerRestOfWidth = (width = LARGE_DRAWER_WIDTH) =>
    `calc(100% - ${width} - var(--drawer-right-position, 0px))`;

export const BLADE_PUSHPAGE = {
    SELECTOR: '.pendo-page',
    MARGINRIGHT: 0,
};

export const ZINDEX = {
    topic: 502,
    automationRule: 1051,
    vocItem: 1050,
    vocItemStacked: 1049,
    suggestedFeedback: 1049,
};
